import { useTranslation } from 'react-i18next';
import { List } from 'lucide-react';
import { GuideSection } from '../components/GuideSection';
import { GuideSubSection } from '../components/GuideSubSection';

export function TicketListSection() {
  const { t } = useTranslation('help');
  const s = 'sections.ticketList';

  return (
    <GuideSection
      id="ticket-list"
      title={t(`${s}.title`)}
      description={t(`${s}.description`)}
      icon={List}
    >
      <GuideSubSection title={t(`${s}.typeTabs.title`)}>
        <p>{t(`${s}.typeTabs.p1`)}</p>
        <p>{t(`${s}.typeTabs.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.filtering.title`)}>
        <p>{t(`${s}.filtering.p1`)}</p>
        <p>{t(`${s}.filtering.p2`)}</p>
        <p>{t(`${s}.filtering.p3`)}</p>
        <p>{t(`${s}.filtering.p4`)}</p>
        <p>{t(`${s}.filtering.p5`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.sorting.title`)}>
        <p>{t(`${s}.sorting.p1`)}</p>
        <p>{t(`${s}.sorting.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.search.title`)}>
        <p>{t(`${s}.search.p1`)}</p>
        <p>{t(`${s}.search.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.savedFilters.title`)}>
        <p>{t(`${s}.savedFilters.p1`)}</p>
        <p>{t(`${s}.savedFilters.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.bulkActions.title`)}>
        <p>{t(`${s}.bulkActions.p1`)}</p>
        <p>{t(`${s}.bulkActions.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.csvExport.title`)}>
        <p>{t(`${s}.csvExport.p1`)}</p>
        <p>{t(`${s}.csvExport.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.pagination.title`)}>
        <p>{t(`${s}.pagination.p1`)}</p>
        <p>{t(`${s}.pagination.p2`)}</p>
        <p>{t(`${s}.pagination.p3`)}</p>
      </GuideSubSection>
    </GuideSection>
  );
}
